import { Component } from '@theme/component';

/**
 * Mobile purchase bar for course pages. It stays hidden while the purchase card is on screen
 * and appears when the card scrolls out of view. Without JavaScript the bar is simply
 * always visible, so the purchase path keeps working.
 *
 * @typedef {object} Refs
 *
 * @extends {Component<Refs>}
 */
class CourseStickyBar extends Component {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    super.connectedCallback();
    this.#observe();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#observe();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  #observe() {
    this.#observer?.disconnect();

    const buyCard = document.getElementById('course-buy');
    const bar = this.querySelector('.course-sticky__bar');
    if (!buyCard || !(bar instanceof HTMLElement) || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        if (entry) bar.dataset.hidden = String(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    this.#observer.observe(buyCard);
  }
}

if (!customElements.get('course-sticky-bar')) {
  customElements.define('course-sticky-bar', CourseStickyBar);
}
